import styled from 'styled-components';

import Button from '../Button';

const PermissionsListContainer = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
`;

const GrowContainer = styled.div`
    flex-grow: 1;
`;

const ControlBar = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    flex-direction: row;
    justify-content: flex-end;
`;

const AddButton = styled(Button)`
    && {
        margin-left: ${({ theme }) => theme.spacing(1)};
    }
`;

const ControlContainer = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    display: flex;
    flex-direction: row;
`;

const PermissionsSearch = styled.div`
    && {
        flex: 1 1 auto;
        margin-right: ${({ theme }) => theme.spacing(2)};
    }
`;

export { PermissionsListContainer,
  GrowContainer,
  ControlBar,
  PermissionsSearch,
  AddButton,
  ControlContainer };
